<template>
  <!-- 详情 -->
  <div class="detail">
    <basepanel>
      <div class="top">
        <h2 v-if="content.subject">{{content.$document.title}}</h2>
        <h2 v-else-if="caseTitle">{{caseTitle }}</h2>
        <h2 v-else>{{content.position}}</h2>

        <div class="top2" v-if="content.new_data">
          <span>发布日期：{{ content.new_data }}</span>
          <span>来源：{{ content.textfield }}</span>
          <!-- <span>浏览量：555次</span> -->
        </div>
      </div>
      <div class="outer-box">
        <div class="content">
          <div id="dplayer"></div>
          <!-- <video controls autoplay loop :src="caselist[caseIndex]"></video> -->
          <div v-if="show" class="pc imgp" v-html="content.htmleditor">{{ content.htmleditor }}</div>
          <div v-else class="phone imgp" v-html="content.htmleditor">{{ content.htmleditor }}</div>
          <!-- 项目案例 -->
          <p v-if="caseExplain" style="text-align: justify">{{caseExplain}}</p>

          <!-- 加入我们详情 -->
          <div class="jion" v-if="content.position">
            <!-- 福利 -->
            <div class="info1">
              <p class="f1-p">{{content.salary}}</p>
              <p
                v-if="content.place"
              >{{content.place}}·{{content.experience}}·{{content.education}}·{{content.number}}</p>
              <p>{{content.label_2_1}}发布</p>

              <p v-if="this.welfare[0]">
                <span class="f1-sp" v-for="(val,i) in this.welfare" :key="i">{{val}}</span>
              </p>
            </div>
            <!-- 职位信息 -->
            <div class="info">
              <h3 v-if="content.information">职位信息</h3>
              <div class="in1">
                <p v-for="text in this.info" :key="text.id">{{ text }}</p>
              </div>

              <h3 v-if="content.explain">职位要求</h3>
              <div class="in2">
                <p v-for="exp in this.info2" :key="exp.id">{{ exp }}</p>
              </div>
            </div>
            <!-- 联系方式 -->
            <div class="info3">
              <h3>联系方式</h3>
              <p>
                <span>
                  <i class="el-icon-user"></i>
                  联系人：{{content.contacts}}
                </span>
              </p>
              <p>
                <span>
                  <i class="el-icon-phone-outline"></i>
                  联系电话：{{content.phone}}
                </span>
              </p>
              <p>
                <span>
                  <i class="el-icon-message"></i>
                  简历投递邮箱：{{content.mailbox}}
                </span>
              </p>
              <!-- <p class="in3">
                <span class="el-icon-location-outline">
                  工作地点：{{content.address}}
                </span>
              </p>-->
              <p>
                <span>
                  <i class="el-icon-location-outline"></i>
                  工作地点：{{content.address}}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="bottom">
          <!-- <div class="right" v-if="prePath == 'home'" @click="back">返回上一页</div> -->
          <div class="right" @click="back">返回上一级</div>
        </div>
      </div>
    </basepanel>
  </div>
</template>

<script>
import DPlayer from "dplayer";
import basepanel from "../components/BasePanel";
import local from "../utils/local";
import { view } from "../api/index";
export default {
  name: "detail",
  components: { basepanel },
  data() {
    return {
      content: {},
      info: [],
      info2: [],
      welfare: [],
      videoUrl: "",
      screenWidth: document.body.clientWidth,
      caseExplain: "",
      caseTitle: "",
      caseIndex: 0,
      caselist: [
        require("../assets/video/city.mp4"),
        require("../assets/video/yl.mp4"),
        require("../assets/video/coummit.mp4")
      ],
      prePath: "",
      newsappId:0,
    };
  },
  computed: {
    // 导航是否完整显示
    show: function() {
      return this.screenWidth >= 1024 ? true : false;
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    // 获取数据
    async getData(id) {
      let send = {
        url: {
          id
        }
      };
      let res = await view(send);
      if (res.type == "success") {
        this.content = res.data.data;
        this.newsappId =  res.data.document.appId
        if(this.content.information){
        this.info = this.content.information.split("\n"); //岗位职责 任职资格
        }
        if( this.content.welfare){
        this.welfare = this.content.welfare.split("，"); //待遇
        }
        if(this.content.explain){
        this.info2 = this.content.explain.split("\n"); //任职要求

        }
      } else {
        console.log(res.msg);
      }
     

    },
    // 获取视频附件
    getFileInfo() {
      //本地加载
      let options = {
        container: document.getElementById("dplayer"),
        autoplay: true,
        video: {
          // url: this.videoUrl
          url: this.caselist[this.caseIndex]
        }
      };
      const dp = new DPlayer(options);
      dp.play();
      // let send = {
      //   url: {
      //     id
      //   }
      // };

      //   let res = await listFileInfoByDocumentId(send);
      //   if (res.type == "success") {
      //     // console.log(res.data)
      //     // 附件存在，且为视频格式时播放视频
      //     if (
      //       res.data.length > 0 &&
      //       res.data[0].type &&
      //       res.data[0].type.indexOf("video") > -1
      //     ) {
      //       this.videoUrl = this.$srcUrl + res.data[0].id;
      //       let options = {
      //         container: document.getElementById("dplayer"),
      //         autoplay: true,
      //         video: {
      //           // url: this.videoUrl
      //           url: this.caselist[this.caseIndex]
      //         }
      //       };
      //       const dp = new DPlayer(options);
      //       dp.play();
      //     } else {
      //       // 附件不存在
      //     }
      //   } else {
      //     console.log(res.msg);
      //   }
    },

    // loadFooter() {
    //   // local.remove("explainInfo")
    //   let options = {
    //     container: document.getElementById("dplayer"),
    //     autoplay: true,
    //     video: {
    //       url:this.caselist[this.caseIndex]
    //     }
    //   };
    //   const dp = new DPlayer(options);
    //   dp.play();
    // },
    //图片居中
    imgCenter(cid) {
      if(cid == this.$map.newsappId){
        this.$nextTick(function() {
          let content = document.getElementsByClassName("imgp")[0];
          let imgs = content.getElementsByTagName("img")
          let pele = content.getElementsByTagName("p")
          for(let i of pele){
            i.style.textIndent = "2rem"
          }
          for(let i of imgs){
            // this.findwrapP(i,"p").style.display = "block"
            i.style.display = "block"
            i.style.margin = "0 auto"
          }
        })
      }
    },
    //找目标图片的外层标签

    // findwrapP(eleTarget, str){
    //   let rele = eleTarget;
    //   // console.log(rele.localName)
    //   while(rele.localName != str){
    //     rele = rele.parentElement
    //   }
    //   return rele
    // },
    //加载案例描述
    loadExplain() {
      if (local.get("explainInfo")) {
        this.caseIndex = local.get("explainInfo").caseIndex;
        this.caseExplain = local.get("explainInfo").caseExplain;
        this.caseTitle = local.get("explainInfo").title;
      }
    }
  },
  mounted() {
    if (this.$route.params.id.length <= 2) {
      this.caseIndex = JSON.parse(this.$route.params.id);
      this.getFileInfo();
    }

    this.loadExplain();
    if (this.$route.params.id.length > 2) {
      this.getData(this.$route.params.id);
    } else {
      this.getFileInfo(this.$route.params.id);
    }

    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    
  },
  updated() {
    this.imgCenter(this.newsappId)
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route(to, from) {
      console.log(to, from);
      //做一些路由变化的响应
      //打开加载动画
      // this.loading = true;
      //重新获取数据
      this.$router.go(0);
      // this.getData(this.$route.params.id);
      // this.getFileInfo(this.$route.params.id);
    },
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    }
  }
};
</script>

<style scoped lang="less">
.detail {
  background-color: #ffffff;
  .top {
    border-bottom: 1px solid #bcbcbc;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    h2 {
      width: 84%;
      margin: 10px auto;
      text-align: center;
    }
  }
  .content {
    margin-top: 2vw;
    border-bottom: 1px solid #bcbcbc;
    text-indent: 2rem;
    line-height: 22px;
   


    /deep/ p {
      text-align:justify;
      text-indent:initial;
      text-align: justify;
      color: #333;
      display: block;
      flex-wrap: wrap;
      
    }
    .phone {
      /deep/ img {
        width: 100% !important;
        height: auto !important;
      }
      /deep/strong{
        font-weight: bold;
      }
    }
    // /deep/ img {
    // width: 100% !important;
    // height: auto !important;
    // }
  }
  .bottom {
    margin: 2vw 0 3vw 0;
    display: flex;
    justify-content: flex-end;
    span {
      line-height: 2em;
    }
    .right {
      line-height: 2em;
      cursor: pointer;
    }
  }
  .info {
    align-self: start;
    .in1,
    .in2,
    .in3 {
      padding-left: 33px;
      box-sizing: border-box;
    }
  }
}
@media screen and (min-width: 1200px) {
  .jion {
    color: #333;
    margin-left: 100px;

    .info1 {
      margin-left: 30px;
      .f1-p {
        color: #ff6000;
        font-size: 25px;
      }
      .f1-sp {
        color: #ff6000;
        // background-color:rgb(128,141,142,.3);
        background-color: #fff2e3;
        margin-right: 10px;
        border-radius: 10%;
        padding: 0px 10px;
      }
    }
    .info1,
    .info3 {
      p {
        font-size: 18px;
        line-height: 2.625rem;
        i {
          margin-right: 0.5rem;
          margin-left: 32px;
        }
      }
    }

    .info,
    .info1,
    .info3 {
      // padding-left: 12px;

      h3 {
        line-height: 40px;
        font-size: 25px;
        font-weight: bold;
        letter-spacing: 3px;
        margin-top: 2.75rem;
        margin-bottom: 30spx;
      }

      div {
        line-height: 50px;
        font-size: 18px;
        letter-spacing: 3px;
      }
    }
  }
  .top {
    line-height: 52px;
    h2 {
      font-size: 45px;
      line-height: 90px;
    }
  }
  .content {
    /deep/p {
      // font-size: 22px;
      line-height: 2em;
    }
     /deep/strong{
        font-weight: bold;
      }
  }
  .right {
    font-size: 22px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  //ipad pro
  .jion {
    // margin-left: 100px;
    .info1 {
      padding-left: 1.625rem;
      .f1-p {
        color: #ff6000;
        font-size: 60px;
      }
      .f1-sp {
        color: #ff6000;
        background-color: #fff2e3;
        margin-right: 2.625rem;
        border-radius: 10%;
        padding: 1px 10px;
      }
    }
    .info1,
    .info3 {
      p {
        font-size: 36px;
        line-height: 4.8125rem;
        i {
          margin-right: 10px;
          margin-left: 32px;
        }
      }
    }

    .info,
    .info1,
    .info3 {
      h3 {
        line-height: 5.1875rem;
        font-size: 50px;
        font-weight: bold;
        letter-spacing: 3px;
        margin-top: 12px;
      }

      div {
        line-height: 4.8125rem;
        font-size: 36px;
        letter-spacing: 3px;
      }
    }
  }
  .top {
    line-height: 48px;
    h2 {
      font-size: 45px;
    }
  }
  .content {
    /deep/p {
      // font-size: 18px;
      line-height: 2em;
    }
     /deep/strong{
        font-weight: bold;
      }
  }
  .right {
    font-size: 18px;
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  //ipad
  .jion {
    // margin-left: 100px;

    .info1 {
      padding-left: 1.6875rem;
      .f1-p {
        color: #ff6000;
        font-size: 60px;
      }
      .f1-sp {
        color: #ff6000;
        // background-color:rgb(128,141,142,.3);
        background-color: #fff2e3;
        margin-right: 15px;
        border-radius: 10%;
        padding: 0px 5px;
      }
    }
    .info1,
    .info3 {
      p {
        font-size: 25px;
        line-height: 50px;
        i {
          margin-right: 10px;
          margin-left: 32px;
        }
      }
    }

    .info,
    .info1,
    .info3 {
      h3 {
        line-height: 6.1875rem;
        font-size: 40px;
        font-weight: bold;
        letter-spacing: 3px;
        margin-top: 12px;
      }
      div {
        line-height: 30px;
        font-size: 25px;
        letter-spacing: 3px;
      }
    }
  }
  .top {
    line-height: 38px;
    h2 {
      font-size: 40px;
    }
  }
  .content {
    /deep/p {
      // font-size: 16px;
      line-height: 2em;
    }
     /deep/strong{
        font-weight: bold;
      }
  }
  .right {
    font-size: 16px;
  }
}
@media screen and (max-width: 414px) {
  //phone
  .jion {
    color: #333;
    // margin-left: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .info1 {
      // margin-left: 30px;
      .f1-p {
        color: #ff6000;
        font-size: 25px;
        align-self: start;
      }
      .f1-sp {
        color: #ff6000;
        // background-color:rgb(128,141,142,.3);
        background-color: #fff2e3;
        margin-right: 10px;
        border-radius: 10%;
        padding: 0px 10px;
      }
    }
    .info1 {
      width: 84%;
      padding-left: 10px;
    }
    .in3 {
      span {
        padding-left: 31px;
        line-height: 30px;
      }
    }
    .info3 {
      display: flex;
      flex-direction: column;
      align-items: start;
      p {
        font-size: 15px;
        line-height: 30px !important;
        padding-left: 32px;
        padding-right: 32px;
        box-sizing: border-box;
        // i {
        //   margin-left: 32px;
        // }
      }
    }
    .info {
      display: flex;
      flex-direction: column;
      align-items: center;
      .in1,
      .in2,
      .in3 {
        padding-left: 0px;
      }
    }

    .info,
    .info1,
    .info3 {

      h3 {
        align-self: start;
        margin-top: 26px;
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 3px;
      }
      p {
        font-size:14px;
        text-align: justify;
            // letter-spacing: 2px;
      }
      div {
        width: 80%;
        line-height: 90px;
        font-size: 14px;
        letter-spacing: 3px;
        // padding-left: 30px;
      }
    }
  }
  .top {
    line-height: 32px;
    h2 {
      font-size: 18px;
    }
  }
  .content {
    /deep/p {
      // font-size: 14px;
      line-height: 2em;
    }
     /deep/strong{
        font-weight: bold;
      }
  }
  .right {
    font-size: 14px;
  }
}
</style>
